import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import type { SessionUser } from 'src/shared/session';

import { LoginModalBody } from './components/LoginModalBody';

export const useLoginModal = createModalHook<
	{
		user?: SessionUser;
		googleAuthEnabled: boolean;
		showContinueAsGuest: boolean;
		email: string;
	},
	{ user: SessionUser | undefined; continueAsGuest?: boolean }
>({
	name: 'PromotePageLoginModal',
	stylesOverrides: {
		width: 420,
	},
	heading: function PromotePageLoginModalHeading({ initialFocusAttributes }) {
		return (
			<Text
				as="h1"
				variant="heading"
				size="small"
				fontWeight="bold"
				className="text-typography-strong mb-4 text-center"
				{...initialFocusAttributes}
			>
				<Translate value="fe.components.login_or_join.log_in" />
			</Text>
		);
	},
	body: function PromotePageLoginModalBody({ options, closeModal }) {
		return (
			<LoginModalBody
				user={options.user}
				email={options.email}
				showContinueAsGuest={options.showContinueAsGuest}
				googleAuthEnabled={options.googleAuthEnabled}
				onSuccess={(user) => closeModal({ user })}
				onContinueAsGuest={() => closeModal({ user: undefined, continueAsGuest: true })}
			/>
		);
	},
});
